import Marquee from "react-fast-marquee";
import { useEffect, useState } from "react";
import { Check } from "lucide-react";
import { IMAGES } from "@/data/content";
import { useLang } from "@/i18n";
import { SectionLabel } from "./ui";
import { Reveal } from "./Reveal";

export const WhyKonek = () => {
  const { t } = useLang();
  const w = t.why;
  const [play, setPlay] = useState(true);
  useEffect(() => {
    setPlay(!window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  }, []);
  return (
    <>
      {/* Editorial marquee band */}
      <div className="bg-white py-7 border-y border-navy-100 overflow-hidden" data-testid="marquee-band">
        <Marquee speed={45} gradient={false} autoFill play={play}>
          {t.marquee.map((m) => (
            <span key={m} className="mx-8 inline-flex items-center gap-8">
              <span className="font-display text-2xl md:text-4xl font-bold gradient-text whitespace-nowrap">
                {m}
              </span>
              <span className="h-2.5 w-2.5 rounded-full bg-gold-500" />
            </span>
          ))}
        </Marquee>
      </div>

      <section id="why" data-testid="why-konek-section" className="py-24 md:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-14 items-center">
          <Reveal className="lg:col-span-6 relative">
            <div className="rounded-[2rem] overflow-hidden ring-1 ring-navy-100 shadow-xl">
              <img
                src={IMAGES.community}
                alt={w.imgAlt}
                className="w-full h-[420px] object-cover"
                loading="lazy"
                decoding="async"
              />
            </div>
            <div className="absolute -bottom-6 -right-4 sm:right-8 bg-navy-900 text-white rounded-2xl px-6 py-5 shadow-xl">
              <p className="font-display text-2xl font-bold text-gold-400">{w.langsTitle}</p>
              <p className="text-sm text-white/70">{w.langsSub}</p>
            </div>
          </Reveal>

          <div className="lg:col-span-6">
            <Reveal>
              <SectionLabel>{w.label}</SectionLabel>
              <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold text-navy-900 leading-tight">
                {w.title}
              </h2>
              <p className="mt-5 text-lg text-charcoal-700 leading-relaxed">{w.sub}</p>
            </Reveal>

            <ul className="mt-8 space-y-4">
              {w.points.map((p, i) => (
                <Reveal key={p} delay={i * 0.05}>
                  <li className="flex items-start gap-4">
                    <span className="mt-0.5 flex h-7 w-7 items-center justify-center rounded-full bg-gold-500 text-navy-900 shrink-0">
                      <Check size={16} strokeWidth={2.5} />
                    </span>
                    <span className="text-[17px] text-charcoal-900 leading-relaxed">{p}</span>
                  </li>
                </Reveal>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </>
  );
};
